<script setup lang="ts">
import GenericDialog from './GenericDialog.vue'
import { useSpeckleAuthStore } from '@haskoning/vue-speckle'
import { computed, onMounted, ref } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
})

const speckleAuthStore = useSpeckleAuthStore()

const emit = defineEmits(['cancel', 'update:modelValue'])

const redirectUrl = ref<string | null>(null)

const dialog = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    updateShowDialog(value)
  }
})

const updateShowDialog = (value: boolean) => {
  emit('update:modelValue', value)
}

const onClickLogin = () => {
  speckleAuthStore.goToSpeckleAuthPage(redirectUrl.value)
}

onMounted(() => (redirectUrl.value = window.location.href))
</script>

<template>
  <GenericDialog v-model="dialog">
    <template #title>Speckle login required</template>
    <template #default>
      <p>You need to log in to Speckle before performing this action.</p>
    </template>
    <template #actions>
      <v-btn variant="text" color="primary" @click="updateShowDialog(false)"> Cancel </v-btn>
      <v-btn variant="text" color="primary" @click="onClickLogin"> Login with Speckle </v-btn>
    </template>
  </GenericDialog>
</template>

<style scoped></style>
